import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import ContentTitle from "components/common/ContentTitle";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { PersonalReferenceStatus } from "libs/configs/constant";
import { get } from "lodash-es";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPersonalReference,
  selectPersonalDetail,
  selectPersonalState
} from "redux/modules/personalSlice";
import PersonalService from "services/PersonalService";

export default function PersonalReference() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const personalDetail = useSelector(selectPersonalDetail);
  const personalState = useSelector(selectPersonalState);

  const personalId = get(personalDetail, "personalID", "");
  const personalReference = get(personalState, "referenceList", {});
  const referenceToMeList = get(personalReference, "personal", []);
  const referenceToPersonList = get(personalReference, "refPersonal", []);
  const isReferingToMe = referenceToMeList.length ? true : false;

  useEffect(() => {
    if (personalId) {
      dispatch(getPersonalReference(personalId));
    }
  }, [dispatch, personalId]);

  const hasDataList = !!(
    !personalState.isLoading &&
    (referenceToMeList.length || referenceToPersonList.length)
  );

  const getStatusName = (status) => {
    if (status === PersonalReferenceStatus.Approved) {
      return "Approved";
    }
    if (status === PersonalReferenceStatus.Pending) {
      return "Pending";
    }
    if (status === PersonalReferenceStatus.Canceled) {
      return "Canceled";
    }
    return "";
  };

  return (
    <div>
      <ContentTitle subTitle="" title="Personal Dependent" />
      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={5}>
                <Typography variant="h6">
                  {isReferingToMe
                    ? "People referring to me"
                    : "The personal Dependent"}
                </Typography>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell align="center" style={{ width: 30 }}>
                No.
              </StyledTableCell>
              <StyledTableCell>First name</StyledTableCell>
              <StyledTableCell>Last name</StyledTableCell>
              <StyledTableCell>Relationship</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {personalState.isLoading && (
              <TableRow style={{ borderTop: 1 }}>
                <TableCell colSpan={4} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            )}
            {!hasDataList && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No referring detail.
                </TableCell>
              </TableRow>
            )}
            {isReferingToMe &&
              !personalState.isLoading &&
              referenceToMeList.map((personal, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell>{personal.refFirstname}</TableCell>
                  <TableCell>{personal.refLastname}</TableCell>
                  <TableCell>{personal.relationshipName}</TableCell>
                  <TableCell>
                    {personal?.status === "P" && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.buttonViewDetail}
                          onClick={async () => {
                            if (
                              !window.confirm(
                                "Do you want to approve this person?"
                              )
                            ) {
                              return;
                            }

                            const res =
                              await PersonalService.apporvePersonalReference({
                                referenceID: personal.referenceID,
                                // personalID: personal.personalID,
                                // refpersonalID: personal.refpersonalID,
                                Status: PersonalReferenceStatus.Approved,
                              });

                            if (res.status) {
                              dispatch(getPersonalReference(personalId));
                            }
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.buttonViewDetail}
                          style={{
                            marginLeft: 8,
                            backgroundColor: theme.palette.error.main,
                          }}
                          onClick={async () => {
                            if (
                              !window.confirm(
                                "Do you want to cancel this person?"
                              )
                            ) {
                              return;
                            }

                            const res =
                              await PersonalService.apporvePersonalReference({
                                referenceID: personal.referenceID,
                                // personalID: personal.personalID,
                                // refpersonalID: personal.refpersonalID,
                                Status: PersonalReferenceStatus.Canceled,
                              });

                            if (res.status) {
                              dispatch(getPersonalReference(personalId));
                            }
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                    {personal?.status === "A" && (
                      <span style={{ color: "#1094d8", fontWeight: "bold" }}>
                        Approved
                      </span>
                    )}
                    {personal?.status === "C" && (
                      <span
                        style={{
                          color: theme.palette.error.main,
                          fontWeight: "bold",
                        }}
                      >
                        Cancel
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            {!isReferingToMe &&
              !personalState.isLoading &&
              referenceToPersonList.map((personal, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell>{personal.firstname}</TableCell>
                  <TableCell>{personal.lastname}</TableCell>
                  <TableCell>{getStatusName(personal.status)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
